export const errorHandle: any = {
  401: '未授权,请重新登录',
  400: '错误请求',
  403: '拒绝访问',
  404: '请求错误,未找到该资源',
  405: '请求方法未允许',
  408: '请求超时',
  500: '网络出错了',
  503: '服务不可用',
  505: 'http版本不支持该请求',
};
